import { Tooltip } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { isLegislationHealthConcerning } from "./lib/legislation-health-utils.mjs"

export function LegislationHealthIcon({ legislationId }) {
    const { legislationHealth } = useBoundContext()
    if (!legislationHealth || !legislationId) return null

    const health = legislationHealth[String(legislationId)]
    if (!health) return null

    const isOk = health.status === "ok"
    const isRedirect = health.status === "redirect"
    const date = health.checkedAt ? new Date(health.checkedAt).toLocaleDateString() : null
    const dateLabel = date ? ` (checked ${date})` : ""

    if (isOk) {
        const { contentCheck } = health
        if (contentCheck?.status === "checking") {
            return (
                <Tooltip title="Checking content relevance…" arrow>
                    <span>
                        <Iconify
                            icon="mdi:loading"
                            sx={{
                                color: "text.disabled",
                                fontSize: 20,
                                flexShrink: 0,
                                "@keyframes legislationHealthSpin": {
                                    from: { transform: "rotate(0deg)" },
                                    to: { transform: "rotate(360deg)" },
                                },
                                animation: "legislationHealthSpin 1s linear infinite",
                            }}
                        />
                    </span>
                </Tooltip>
            )
        }
        if (isLegislationHealthConcerning(health)) {
            const note = contentCheck.note ? ` — ${contentCheck.note}` : ""
            return (
                <Tooltip title={`Legislation content may have changed${note}${dateLabel}`} arrow>
                    <span>
                        <Iconify icon="mdi:alert-circle" sx={{ color: "warning.main", fontSize: 20, flexShrink: 0 }} />
                    </span>
                </Tooltip>
            )
        }
        const okNote = contentCheck?.status === "done" && contentCheck?.note ? ` — ${contentCheck.note}` : ""
        return (
            <Tooltip title={`Link OK${okNote}${dateLabel}`} arrow>
                <span>
                    <Iconify icon="mdi:check-circle" sx={{ color: "success.main", fontSize: 20, flexShrink: 0 }} />
                </span>
            </Tooltip>
        )
    }

    const from = health.originalUrl ? ` (${health.originalUrl}` : ""
    const to = health.suggestedUrl ? ` → ${health.suggestedUrl})` : from ? ")" : ""
    const tip = isRedirect
        ? `Link has moved${from}${to}${dateLabel}`
        : `Link appears broken${from ? `${from})` : ""}${dateLabel}`

    return (
        <Tooltip title={tip} arrow>
            <span>
                <Iconify icon="mdi:close-circle" sx={{ color: "error.main", fontSize: 20, flexShrink: 0 }} />
            </span>
        </Tooltip>
    )
}
